export default function getScrollDimensionValue(dimension, element) {
  return dimension === 'height' ? element.scrollHeight : element.scrollWidth;
}